import { render, staticRenderFns } from "./HeroBannerBeta.vue?vue&type=template&id=f7f7fc4e&scoped=true"
import script from "./HeroBannerBeta.vue?vue&type=script&lang=js"
export * from "./HeroBannerBeta.vue?vue&type=script&lang=js"
import style0 from "./HeroBannerBeta.vue?vue&type=style&index=0&id=f7f7fc4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f7fc4e",
  null
  
)

export default component.exports